import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

export interface Language {
    name: string;
    code: string;
    urlImg: string;
    coname: string;
    labelKey: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports:[MatIconModule, CommonModule, MatMenuModule, MatButtonModule, RouterModule, TranslateModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  isLoggedIn: boolean = false;

  languages: Language[] = [
    { name: 'Italian', code: 'it-IT', urlImg: 'img/italy.png' , coname: "IT", labelKey: 'header.language.italian' },
    { name: 'English', code: 'en-US', urlImg: 'img/united-kingdom.png', coname: "EN", labelKey: 'header.language.english' },
    { name: 'French', code: 'fr-FR', urlImg: 'img/france.png', coname: "FR", labelKey: 'header.language.french' },
    { name: 'Greek', code: 'el-GR', urlImg: 'img/greece.png', coname: "GR", labelKey: 'header.language.greek' },
    { name: 'Turkish', code: 'tr-TR', urlImg: 'img/turkey.png', coname: "TR", labelKey: 'header.language.turkish' },
    { name: 'Polish', code: 'pl-PL', urlImg: 'img/poland.png', coname: "PL", labelKey: 'header.language.polish' }
  ];

  selectedLanguage = this.languages[1];

  constructor(private authService: AuthService, private router: Router, private translate: TranslateService) {
    const storedLanguage = localStorage.getItem('language');
    const initialLanguage = this.languages.find(language => language.code === storedLanguage) || this.languages[0];
    this.selectedLanguage = initialLanguage;
    this.translate.use(initialLanguage.code);
  }

  ngOnInit() {
    this.authService.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
      console.log(this.isLoggedIn);
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  //FUNZIONE CHE PERMETTE DI CAMBIARE LINGUA DELLA PAGINA USANDO IL SERVIZIO TRANSLATE

  changeLanguage(lang: Language) {
    this.selectedLanguage = lang;
    localStorage.setItem('language', lang.code);
    this.translate.use(lang.code);
    console.log("Lingua cambiata in: " + lang.name);
  }
}
